<template>
  <v-dialog
    v-model="navigation.CRMWhatsappContactLatitudeLongitudeLocationDialogIsVisible"
    @update:model-value="navigation.CRMWhatsappContactLatitudeLongitudeLocationDialogIsVisible == false ? closeCRMWhatsappContactLatitudeLongitudeLocationDialog() : null"
    max-width="65vw"
    @contextmenu.prevent="null"
    style="user-select: none; cursor: default;"
  >
    <v-card>
      <div style="max-height: 90vh; display: flex; flex-direction: column;">
        <div style="position: sticky; top: 0; z-index: 10; background: white;">
          <v-card color="primary" rounded="0" elevation="0">
            <div class="twoColumnContainer">
              <div class="titleContainer">
                <div style="display: flex; align-items: center;">
                  <v-icon color="indigo" size="large">mdi-map-marker</v-icon>
                  <v-icon color="indigo" style="margin-right: 10px;">{{ {'insert': 'mdi-plus-circle', 'update': 'mdi-pencil', 'delete': 'mdi-delete'}[navigation.CRMWhatsappContactLatitudeLongitudeLocationDialogAction] }}</v-icon>
                  <h3>{{ {'insert': 'AGREGAR', 'update': 'ACTUALIZAR', 'delete': 'ELIMINAR'}[navigation.CRMWhatsappContactLatitudeLongitudeLocationDialogAction] }} UBICACIÓN DEL CONTACTO</h3>
                </div>
              </div>
              <div class="buttonsContainer">
                <v-btn @click="closeCRMWhatsappContactLatitudeLongitudeLocationDialog()" color="error" class="hoverableText">
                  <v-icon style="margin-right: 10px;">mdi-close-circle</v-icon>
                  <p>CERRAR</p>
                </v-btn>
              </div>
            </div>
          </v-card>
          <v-card color="indigo" elevation="0" rounded="0" style="height: 2px;"></v-card>
        </div>
        <div style="flex: 1; overflow-y: auto;">
          <template v-if="loader.getSystemInformationData || loader.selectCRMWhatsappContactLatitudeLongitudeLocationFromCRMWhatsappContactLatitudeLongitudeLocationDialog">
            <div style="height: 500px; width: 100%;">
              <AppLoaderScreen
                :appLogoSize="'x-small'"
                :loadingText="'Cargando ubicación del contacto'"
                :dotsToAnimate="3"
                style="width: 100%; height: 100%;"
              ></AppLoaderScreen>
            </div>
          </template>
          <template v-else>
            <div style="padding: 15px;">
              <v-text-field
                ref="CRMWhatsappContactLatitudeLongitudeLocationName"
                v-model="input.CRMWhatsappContactLatitudeLongitudeLocationName"
                :loader="loader.generalLoader"
                :disabled="loader.generalLoader || navigation.CRMWhatsappContactLatitudeLongitudeLocationDialogAction == 'delete'"
                label="Nombre"
                variant="outlined"
                density="compact"
                autocomplete="off"
                prepend-inner-icon="mdi-alpha-a-box"
                clearable
                hide-details
                style="margin-bottom: 15px;"
              ></v-text-field>
              <v-textarea
                v-model="input.CRMWhatsappContactLatitudeLongitudeLocationDescription"
                :loader="loader.generalLoader"
                :disabled="loader.generalLoader || navigation.CRMWhatsappContactLatitudeLongitudeLocationDialogAction == 'delete'"
                label="Descripción"
                variant="outlined"
                density="compact"
                autocomplete="off"
                prepend-inner-icon="mdi-alpha-b-box"
                rows="3"
                max-rows="5"
                auto-grow
                clearable
                hide-details
                style="margin-bottom: 15px;"
              ></v-textarea>
              <v-card color="primary" elevation="0" style="width: 100%; padding: 2px; margin-bottom: 15px;">
                <MapComponent
                  :key="input.CRMWhatsappContactLatitudeLongitudeLocationMapID"
                  :width="'100%'"
                  :height="'300px'"
                  :showPoint="true"
                  :showPointDrawPoint="true"
                  :showPointDraggable="true"
                  :showPointPoint="{latitude: parseFloat(input.CRMWhatsappContactLatitudeLongitudeLocationLatitude), longitude: parseFloat(input.CRMWhatsappContactLatitudeLongitudeLocationLongitude)}"
                  :showPointName="input.CRMWhatsappContactLatitudeLongitudeLocationName || 'No registrado'"
                  :displayMaps="
                    systemInformationData.CRMLocalities.map(CRMLocality => 
                    ({
                      'mapID': CRMLocality.CRMLocalityID,
                      'mapName': CRMLocality.CRMLocalityName, 
                      'mapColor': CRMLocality.CRMLocalityColor, 
                      'mapFontColor': CRMLocality.CRMLocalityFontColor, 
                      'mapCenterLatitude': CRMLocality.CRMLocalityMap.CRMLocalityMapCenterLatitude, 
                      'mapCenterLongitude': CRMLocality.CRMLocalityMap.CRMLocalityMapCenterLongitude, 
                      'mapPoints': CRMLocality.CRMLocalityMap.CRMLocalityMapPoints.map(CRMLocalityMapPoint => 
                      ({
                        'mapPointLatitude': CRMLocalityMapPoint.CRMLocalityMapPointLatitude, 
                        'mapPointLongitude': CRMLocalityMapPoint.CRMLocalityMapPointLongitude
                      })),
                      'mapDivisions': CRMLocality.CRMLocalityMap.CRMLocalityMapDivisions.map(CRMLocalityMapDivision => 
                      ({
                        'mapDivisionName': CRMLocalityMapDivision.CRMLocalityMapDivisionName, 
                        'mapDivisionDescription': CRMLocalityMapDivision.CRMLocalityMapDivisionDescription,
                        'mapDivisionColor': CRMLocalityMapDivision.CRMLocalityMapDivisionColor,
                        'mapDivisionIsDisplayOnly': CRMLocalityMapDivision.CRMLocalityMapDivisionIsDisplayOnly,
                        'mapDivisionPoints': CRMLocalityMapDivision.CRMLocalityMapDivisionPoints.map(CRMLocalityMapDivisionPoint => 
                        ({
                          'mapDivisionPointLatitude': CRMLocalityMapDivisionPoint.CRMLocalityMapDivisionPointLatitude, 
                          'mapDivisionPointLongitude': CRMLocalityMapDivisionPoint.CRMLocalityMapDivisionPointLongitude
                        }))
                      }))
                    }))"
                    @showPointUpdate="handleShowPointUpdate"
                    :style="loader.generalLoader || navigation.CRMWhatsappContactLatitudeLongitudeLocationDialogAction == 'delete' ? 'opacity: 0.5; pointer-events: none;' : ''"
                ></MapComponent>
              </v-card>
              <div class="twoInputContainer">
                <v-text-field
                  v-model="input.CRMWhatsappContactLatitudeLongitudeLocationLatitude" 
                  @keypress="(event) => { const char = String.fromCharCode(event.keyCode || event.which); if (!/^[0-9.-]$/.test(char)) { event.preventDefault(); return; } if (char == '-' && (event.target.value.length > 0 || event.target.value.includes('-'))) { event.preventDefault(); } if (char == '.' && event.target.value.includes('.')) { event.preventDefault(); } }"
                  @input="input.CRMWhatsappContactLatitudeLongitudeLocationMapID = Math.random().toString(36).substring(2, 15)"
                  :loader="loader.generalLoader"
                  :disabled="loader.generalLoader || navigation.CRMWhatsappContactLatitudeLongitudeLocationDialogAction == 'delete'"
                  label="Latitud" 
                  variant="outlined" 
                  density="compact"
                  autocomplete="off"
                  prepend-inner-icon="mdi-numeric-1-box"
                  clearable
                  hide-details
                ></v-text-field>
                <v-text-field
                  v-model="input.CRMWhatsappContactLatitudeLongitudeLocationLongitude" 
                  @keypress="(event) => { const char = String.fromCharCode(event.keyCode || event.which); if (!/^[0-9.-]$/.test(char)) { event.preventDefault(); return; } if (char == '-' && (event.target.value.length > 0 || event.target.value.includes('-'))) { event.preventDefault(); } if (char == '.' && event.target.value.includes('.')) { event.preventDefault(); } }"
                  @input="input.CRMWhatsappContactLatitudeLongitudeLocationMapID = Math.random().toString(36).substring(2, 15)"
                  :loader="loader.generalLoader"
                  :disabled="loader.generalLoader || navigation.CRMWhatsappContactLatitudeLongitudeLocationDialogAction == 'delete'"
                  label="Longitud" 
                  variant="outlined" 
                  density="compact"
                  autocomplete="off"
                  prepend-inner-icon="mdi-numeric-1-box"
                  clearable
                  hide-details
                ></v-text-field>
              </div>
            </div>
            <v-card color="indigo" elevation="0" style="height: 2px;"></v-card>
            <v-card color="primary" elevation="0" rounded="0" style="padding: 15px;">
              <v-tooltip :disabled="validateInputForCRMWhatsappContactLatitudeLongitudeLocationDialog(false).success" location="top"> 
                <template v-slot:activator="{ props }">
                  <div v-bind="props">
                    <v-btn 
                      @click="navigation.CRMWhatsappContactLatitudeLongitudeLocationDialogAction == 'insert' ? insertCRMWhatsappContactLatitudeLongitudeLocation() : (navigation.CRMWhatsappContactLatitudeLongitudeLocationDialogAction == 'update' ? updateCRMWhatsappContactLatitudeLongitudeLocation() : deleteCRMWhatsappContactLatitudeLongitudeLocation())" 
                      :disabled="!validateInputForCRMWhatsappContactLatitudeLongitudeLocationDialog(false).success || loader.selectCRMWhatsappContactLatitudeLongitudeLocationFromCRMWhatsappContactLatitudeLongitudeLocationDialog || loader.generalLoader" 
                      color="indigo"
                      class="hoverableText"
                      block
                    >
                      <v-icon style="margin-right: 10px;">{{ {'insert': 'mdi-plus-circle', 'update': 'mdi-pencil', 'delete': 'mdi-delete'}[navigation.CRMWhatsappContactLatitudeLongitudeLocationDialogAction] }}</v-icon>
                      <h3>{{ {'insert': 'AGREGAR', 'update': 'ACTUALIZAR', 'delete': 'ELIMINAR'}[navigation.CRMWhatsappContactLatitudeLongitudeLocationDialogAction] }} UBICACIÓN DEL CONTACTO</h3>
                    </v-btn>
                  </div>
                </template>
                <span style="max-width: 400px; display: block;">{{ validateInputForCRMWhatsappContactLatitudeLongitudeLocationDialog(false).result }}</span>
              </v-tooltip>
            </v-card>
          </template>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<style scoped>
  .twoColumnContainer {
    padding: 15px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    align-items: center;
  }
  .titleContainer {
    display: flex;
    justify-content: flex-start;
  }
  .buttonsContainer {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
  }
  .twoInputContainer {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
  @media (max-width: 1200px) {
    .twoColumnContainer {
      grid-template-columns: repeat(1, 1fr);
    }
    .titleContainer {
      justify-content: center;
    }
    .buttonsContainer {
      justify-content: center;
    }
    .twoInputContainer {
      grid-template-columns: repeat(1, 1fr);
    }
  }
</style>
  
<script>
  import { systemInformation } from '@/utilities/systemInformation';
  import MapComponent from '@/components/MapComponent.vue';
  import AppLoaderScreen from '@/components/AppLoaderScreen.vue';

  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    components: 
    {
      MapComponent,
      AppLoaderScreen
    },
    data: () => 
    ({
      input: 
      {
        CRMWhatsappContactLatitudeLongitudeLocationName: null,
        CRMWhatsappContactLatitudeLongitudeLocationDescription: null,
        CRMWhatsappContactLatitudeLongitudeLocationLatitude: null,
        CRMWhatsappContactLatitudeLongitudeLocationLongitude: null,
        CRMWhatsappContactLatitudeLongitudeLocationMapID: null
      },
      navigation: 
      {
        CRMWhatsappContactID: null,
        CRMWhatsappContactLatitudeLongitudeLocationID: null,
        CRMWhatsappContactLatitudeLongitudeLocationDialogAction: null,
        CRMWhatsappContactLatitudeLongitudeLocationDialogIsVisible: false
      },
      loader: 
      {
        getSystemInformationData: false,
        generalLoader: false,
        selectCRMWhatsappContactLatitudeLongitudeLocationFromCRMWhatsappContactLatitudeLongitudeLocationDialog: false
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgentID: null,
        CRMLocalities: [],
        tooltipDisabled: false
      }
    }),

    methods:
    {
      async selectCRMWhatsappContactLatitudeLongitudeLocationFromCRMWhatsappContactLatitudeLongitudeLocationDialog(){
        this.loader.selectCRMWhatsappContactLatitudeLongitudeLocationFromCRMWhatsappContactLatitudeLongitudeLocationDialog = true;
        const selectCRMWhatsappContactLatitudeLongitudeLocationFromCRMWhatsappContactLatitudeLongitudeLocationDialogRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgentID
          },
          'CRMWhatsappContactID': this.navigation.CRMWhatsappContactID,
          'CRMWhatsappContactLatitudeLongitudeLocationID': this.navigation.CRMWhatsappContactLatitudeLongitudeLocationID
        };
        const selectCRMWhatsappContactLatitudeLongitudeLocationFromCRMWhatsappContactLatitudeLongitudeLocationDialogResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContactLocation/functions/selectCRMWhatsappContactLatitudeLongitudeLocationFromCRMWhatsappContactLatitudeLongitudeLocationDialog', selectCRMWhatsappContactLatitudeLongitudeLocationFromCRMWhatsappContactLatitudeLongitudeLocationDialogRequestQuery);
        if (selectCRMWhatsappContactLatitudeLongitudeLocationFromCRMWhatsappContactLatitudeLongitudeLocationDialogResult.success){
          this.input.CRMWhatsappContactLatitudeLongitudeLocationName = selectCRMWhatsappContactLatitudeLongitudeLocationFromCRMWhatsappContactLatitudeLongitudeLocationDialogResult.result.CRMWhatsappContactLatitudeLongitudeLocationName;
          this.input.CRMWhatsappContactLatitudeLongitudeLocationDescription = selectCRMWhatsappContactLatitudeLongitudeLocationFromCRMWhatsappContactLatitudeLongitudeLocationDialogResult.result.CRMWhatsappContactLatitudeLongitudeLocationDescription;
          this.input.CRMWhatsappContactLatitudeLongitudeLocationLatitude = selectCRMWhatsappContactLatitudeLongitudeLocationFromCRMWhatsappContactLatitudeLongitudeLocationDialogResult.result.CRMWhatsappContactLatitudeLongitudeLocationLatitude;
          this.input.CRMWhatsappContactLatitudeLongitudeLocationLongitude = selectCRMWhatsappContactLatitudeLongitudeLocationFromCRMWhatsappContactLatitudeLongitudeLocationDialogResult.result.CRMWhatsappContactLatitudeLongitudeLocationLongitude;
          this.loader.selectCRMWhatsappContactLatitudeLongitudeLocationFromCRMWhatsappContactLatitudeLongitudeLocationDialog = false;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMWhatsappContactLatitudeLongitudeLocationFromCRMWhatsappContactLatitudeLongitudeLocationDialog_error', 'error', 'Ha ocurrido un error inesperado al obtener la información de la ubicación del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
          this.closeCRMWhatsappContactLatitudeLongitudeLocationDialog();
        }
        this.loader.selectCRMWhatsappContactLatitudeLongitudeLocationFromCRMWhatsappContactLatitudeLongitudeLocationDialog = false;
      },

      async insertCRMWhatsappContactLatitudeLongitudeLocation(){
        if (this.validateInputForCRMWhatsappContactLatitudeLongitudeLocationDialog(true).success){
          this.loader.generalLoader = true;
          const insertCRMWhatsappContactLatitudeLongitudeLocationRequestQuery =
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.systemInformationData.CRMAgentID
            },
            'CRMWhatsappContactID': this.navigation.CRMWhatsappContactID,
            'CRMWhatsappContactLatitudeLongitudeLocationName': this.input.CRMWhatsappContactLatitudeLongitudeLocationName,
            'CRMWhatsappContactLatitudeLongitudeLocationDescription': this.input.CRMWhatsappContactLatitudeLongitudeLocationDescription,
            'CRMWhatsappContactLatitudeLongitudeLocationLatitude': this.input.CRMWhatsappContactLatitudeLongitudeLocationLatitude,
            'CRMWhatsappContactLatitudeLongitudeLocationLongitude': this.input.CRMWhatsappContactLatitudeLongitudeLocationLongitude
          };
          const insertCRMWhatsappContactLatitudeLongitudeLocationResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContactLocation/functions/insertCRMWhatsappContactLatitudeLongitudeLocation', insertCRMWhatsappContactLatitudeLongitudeLocationRequestQuery);  
          if (insertCRMWhatsappContactLatitudeLongitudeLocationResult.success){
            this.$root.notificationDialog.showSystemNotificationDialog('insertCRMWhatsappContactLatitudeLongitudeLocation_success', 'success', `Se ha agregado la ubicación "${this.input.CRMWhatsappContactLatitudeLongitudeLocationName}" del contacto`, null, true);
            this.closeCRMWhatsappContactLatitudeLongitudeLocationDialog();
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('insertCRMWhatsappContactLatitudeLongitudeLocation_error', 'error', `Ha ocurrido un error inesperado al agregar la ubicación "${this.input.CRMWhatsappContactLatitudeLongitudeLocationName}" del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
          }
          this.loader.generalLoader = false;
        }
      },

      async updateCRMWhatsappContactLatitudeLongitudeLocation(){
        if (this.validateInputForCRMWhatsappContactLatitudeLongitudeLocationDialog(true).success){
          this.loader.generalLoader = true;
          const updateCRMWhatsappContactLatitudeLongitudeLocationRequestQuery =
          {
            'localStorage':
            {
              'CRMAccountID': this.systemInformationData.CRMAccountID,
              'CRMAgentID': this.systemInformationData.CRMAgentID
            },
            'CRMWhatsappContactID': this.navigation.CRMWhatsappContactID,
            'CRMWhatsappContactLatitudeLongitudeLocationID': this.navigation.CRMWhatsappContactLatitudeLongitudeLocationID,
            'CRMWhatsappContactLatitudeLongitudeLocationName': this.input.CRMWhatsappContactLatitudeLongitudeLocationName,
            'CRMWhatsappContactLatitudeLongitudeLocationDescription': this.input.CRMWhatsappContactLatitudeLongitudeLocationDescription,
            'CRMWhatsappContactLatitudeLongitudeLocationLatitude': this.input.CRMWhatsappContactLatitudeLongitudeLocationLatitude,
            'CRMWhatsappContactLatitudeLongitudeLocationLongitude': this.input.CRMWhatsappContactLatitudeLongitudeLocationLongitude
          };
          const updateCRMWhatsappContactLatitudeLongitudeLocationResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContactLocation/functions/updateCRMWhatsappContactLatitudeLongitudeLocation', updateCRMWhatsappContactLatitudeLongitudeLocationRequestQuery);
          if (updateCRMWhatsappContactLatitudeLongitudeLocationResult.success){
            this.$root.notificationDialog.showSystemNotificationDialog('updateCRMWhatsappContactLatitudeLongitudeLocation_success', 'success', `Se ha actualizado la ubicación "${this.input.CRMWhatsappContactLatitudeLongitudeLocationName}" del contacto`, null, true);
            this.closeCRMWhatsappContactLatitudeLongitudeLocationDialog();
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('updateCRMWhatsappContactLatitudeLongitudeLocation_error', 'error', `Ha ocurrido un error inesperado al actualizar la ubicación "${this.input.CRMWhatsappContactLatitudeLongitudeLocationName}" del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
          }
          this.loader.generalLoader = false;
        }
      },
  
      async deleteCRMWhatsappContactLatitudeLongitudeLocation(){
        this.loader.generalLoader = true;
        const deleteCRMWhatsappContactLatitudeLongitudeLocationRequestQuery =
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgentID
          },
          'CRMWhatsappContactID': this.navigation.CRMWhatsappContactID,
          'CRMWhatsappContactLatitudeLongitudeLocationID': this.navigation.CRMWhatsappContactLatitudeLongitudeLocationID
        };
        const deleteCRMWhatsappContactLatitudeLongitudeLocationResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMWhatsappContactLocation/functions/deleteCRMWhatsappContactLatitudeLongitudeLocation', deleteCRMWhatsappContactLatitudeLongitudeLocationRequestQuery);
        if (deleteCRMWhatsappContactLatitudeLongitudeLocationResult.success){
          this.$root.notificationDialog.showSystemNotificationDialog('deleteCRMWhatsappContactLatitudeLongitudeLocation_success', 'success', `Se ha eliminado la ubicación "${this.input.CRMWhatsappContactLatitudeLongitudeLocationName}" del contacto`, null, true);
          this.closeCRMWhatsappContactLatitudeLongitudeLocationDialog();
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('deleteCRMWhatsappContactLatitudeLongitudeLocation_error', 'error', `Ha ocurrido un error inesperado al eliminar la ubicación "${this.input.CRMWhatsappContactLatitudeLongitudeLocationName}" del contacto, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema`, null, true);
        }
        this.loader.generalLoader = false;
      },

      validateInputForCRMWhatsappContactLatitudeLongitudeLocationDialog(showSystemNotificationDialog){
        const regularExpressionChecker = /\S/;
        if (this.navigation.CRMWhatsappContactLatitudeLongitudeLocationDialogAction == 'delete'){
          return {success: true, result: null};
        } else if (this.input.CRMWhatsappContactLatitudeLongitudeLocationName == null || !regularExpressionChecker.test(this.input.CRMWhatsappContactLatitudeLongitudeLocationName)){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactLatitudeLongitudeLocationDialog_error', 'warning', 'El nombre de la ubicación del contacto es obligatorio', null, false);
          return {success: false, result: 'El nombre de la ubicación del contacto es obligatorio'};
        } else if (this.input.CRMWhatsappContactLatitudeLongitudeLocationName.length > 100){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactLatitudeLongitudeLocationDialog_error', 'warning', 'El nombre de la ubicación del contacto no puede exceder los 100 caracteres de longitud', null, false);
          return {success: false, result: 'El nombre de la ubicación del contacto no puede exceder los 100 caracteres de longitud'};
        } else if (this.input.CRMWhatsappContactLatitudeLongitudeLocationDescription != null && this.input.CRMWhatsappContactLatitudeLongitudeLocationDescription.length > 65535){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactLatitudeLongitudeLocationDialog_error', 'warning', 'La descripción de la ubicación del contacto no puede exceder los 65535 caracteres de longitud', null, false);
          return {success: false, result: 'La descripción de la ubicación del contacto no puede exceder los 65535 caracteres de longitud'};
        } else if (this.input.CRMWhatsappContactLatitudeLongitudeLocationLatitude == null || this.input.CRMWhatsappContactLatitudeLongitudeLocationLongitude == null){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactLatitudeLongitudeLocationDialog_error', 'warning', 'La latitud y longitud de la ubicación del contacto son obligatorias', null, false);
          return {success: false, result: 'La latitud y longitud de la ubicación del contacto son obligatorias'};
        } else if (!this.isValidLatitudeLongitude(this.input.CRMWhatsappContactLatitudeLongitudeLocationLatitude) || !this.isValidLatitudeLongitude(this.input.CRMWhatsappContactLatitudeLongitudeLocationLongitude)){
          if (showSystemNotificationDialog) this.$root.notificationDialog.showSystemNotificationDialog('validateInputForCRMWhatsappContactLatitudeLongitudeLocationDialog_error', 'warning', 'La latitud y longitud deben ser valores numéricos válidos', null, false);
          return {success: false, result: 'La latitud y longitud deben ser valores numéricos válidos'};
        }
        return {success: true, result: null};
      },

      isValidLatitudeLongitude(value) {
        if (!value) return false;
        if (!/^-?\d*\.?\d*$/.test(value)) return false;
        if (isNaN(parseFloat(value))) return false;
        if (value == this.input.CRMWhatsappContactLatitudeLongitudeLocationLatitude) return parseFloat(value) >= -90 && parseFloat(value) <= 90;
        if (value == this.input.CRMWhatsappContactLatitudeLongitudeLocationLongitude) return parseFloat(value) >= -180 && parseFloat(value) <= 180;
        return false;
      },

      handleShowPointUpdate(showPointUpdate){
        this.navigation.CRMWhatsappContactLatitudeLongitudeLocation.CRMWhatsappContactLatitudeLongitudeLocationLatitude = showPointUpdate.latitude;
        this.navigation.CRMWhatsappContactLatitudeLongitudeLocation.CRMWhatsappContactLatitudeLongitudeLocationLongitude = showPointUpdate.longitude;
      },
      
      async getSystemInformationData(){
        this.loader.getSystemInformationData = true;
        try {
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgentID = systemInformation.getCRMAgentID;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.CRMLocalities = systemInformation.getCRMLocalities;
            this.loader.getSystemInformationData = false;
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappContactLatitudeLongitudeLocationDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
            this.closeCRMWhatsappContactLatitudeLongitudeLocationDialog();
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('CRMWhatsappContactLatitudeLongitudeLocationDialog_getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          this.closeCRMWhatsappContactLatitudeLongitudeLocationDialog();
        }
        this.loader.getSystemInformationData = false;
      },

      async openCRMWhatsappContactLatitudeLongitudeLocationDialog(CRMWhatsappContactID, CRMWhatsappContactLatitudeLongitudeLocationID, CRMWhatsappContactLatitudeLongitudeLocationLatitude, CRMWhatsappContactLatitudeLongitudeLocationLongitude, CRMWhatsappContactLatitudeLongitudeLocationDialogAction){
        await this.getSystemInformationData();
        this.navigation.CRMWhatsappContactID = CRMWhatsappContactID;
        this.navigation.CRMWhatsappContactLatitudeLongitudeLocationID = CRMWhatsappContactLatitudeLongitudeLocationID;
        this.navigation.CRMWhatsappContactLatitudeLongitudeLocationDialogAction = CRMWhatsappContactLatitudeLongitudeLocationDialogAction;
        this.navigation.CRMWhatsappContactLatitudeLongitudeLocationDialogIsVisible = true;
        if (['update', 'delete'].includes(CRMWhatsappContactLatitudeLongitudeLocationDialogAction)) await this.selectCRMWhatsappContactLatitudeLongitudeLocationFromCRMWhatsappContactLatitudeLongitudeLocationDialog();
        if (['insert', 'update'].includes(CRMWhatsappContactLatitudeLongitudeLocationDialogAction)) this.$generalFunctions.default.focusInput(this, 'CRMWhatsappContactLatitudeLongitudeLocationName');
        if (CRMWhatsappContactLatitudeLongitudeLocationDialogAction == 'insert') {
          this.input.CRMWhatsappContactLatitudeLongitudeLocationLatitude = CRMWhatsappContactLatitudeLongitudeLocationLatitude;
          this.input.CRMWhatsappContactLatitudeLongitudeLocationLongitude = CRMWhatsappContactLatitudeLongitudeLocationLongitude;
        }
      },

      closeCRMWhatsappContactLatitudeLongitudeLocationDialog(){
        this.navigation.CRMWhatsappContactLatitudeLongitudeLocationDialogIsVisible = false;
        this.$emit('closeCRMWhatsappContactLatitudeLongitudeLocationDialog');
      }
    }
  }
</script>